var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBeyneLogoBlueCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 60C120 93.1372 93.1372 120 60 120C26.8629 120 0 93.1372 0 60C0 53.7286 0.962122 47.6823 2.7468 42H37.3064C33.4148 46.9075 31.0909 53.1142 31.0909 59.8636C31.0909 75.7544 43.9729 88.6364 59.8636 88.6364C75.7544 88.6364 88.6364 75.7544 88.6364 59.8636C88.6364 44.0185 75.828 31.1645 60 31.0912L7.41101 31.0909C17.6212 12.557 37.3443 0 60 0C93.1372 0 120 26.8629 120 60Z",
    fill: "#0096DD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeyneLogoBlueCircle);
export default __webpack_public_path__ + "static/media/BeyneLogoBlueCircle.9667064ded690967755e1b7656e330f3.svg";
export { ForwardRef as ReactComponent };